import {
  required,
  email,
  password,
  compare,
} from '@rxweb/reactive-form-validators';

export class UserRegistration {
  @required()
  displayName: string;
  @email()
  email: string;
  @password({
    validation: {
      maxLength: 10,
      minLength: 5,
      digit: true,
      specialCharacter: true,
    },
  })
  password: string;
  @compare({ fieldName: 'password' })
  confirmPassword: string;
}
